import { render, staticRenderFns } from "./itemCreateModal.vue?vue&type=template&id=27de0fe4&"
import script from "./itemCreateModal.vue?vue&type=script&lang=ts&"
export * from "./itemCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports